var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarrantyRegister(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 27,
    viewBox: "0 0 22 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1168 14.2864C20.1168 20.1173 16.0351 23.0328 11.1838 24.7237C10.9297 24.8098 10.6538 24.8057 10.4024 24.7121C5.53942 23.0328 1.45776 20.1173 1.45776 14.2864V6.12304C1.45776 5.81375 1.58063 5.51712 1.79933 5.29842C2.01804 5.07972 2.31466 4.95685 2.62395 4.95685C4.95633 4.95685 7.8718 3.55743 9.90097 1.78482C10.148 1.57374 10.4623 1.45776 10.7873 1.45776C11.1122 1.45776 11.4265 1.57374 11.6736 1.78482C13.7144 3.56909 16.6182 4.95685 18.9506 4.95685C19.2599 4.95685 19.5565 5.07972 19.7752 5.29842C19.9939 5.51712 20.1168 5.81375 20.1168 6.12304V14.2864Z",
    stroke: "white",
    strokeWidth: 2.91547,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarrantyRegister);
export default __webpack_public_path__ + "static/media/warranty_register.25553c15b9a3679f0528de40a355244f.svg";
export { ForwardRef as ReactComponent };